import { createSelector } from 'reselect'

import type { BraintreeGatewayConfig, BraintreeState } from './types'

const clientSelector = createSelector(
    (state: BraintreeState) => state.data,
    (btData): string => {
        return btData?.clientToken || ''
    },
)
const btClientConfigSelector = createSelector(
    (state: BraintreeState) => state,
    (btData): Partial<BraintreeGatewayConfig> => {
        return btData?.btClientInstanceConfig?.gatewayConfiguration || {}
    },
)

export { clientSelector, btClientConfigSelector }
